module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "blog-posts-area section-padding"
  }, [_c('div', {
    staticClass: "container xinwen2912"
  }, [_c('div', {
    staticClass: "row buxianshi"
  }, [_c('div', {
    staticClass: "swiper-container",
    staticStyle: {
      "width": "100%",
      "margin": "50px 0px"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper",
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.newslunbo), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide",
      staticStyle: {
        "width": "100%",
        "height": "450px"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "black"
      },
      attrs: {
        "href": '/blogDetails?id=' + item.id + '&cid=' + _vm.thisid
      }
    }, [_c('div', {
      staticStyle: {
        "width": "50%",
        "height": "400px",
        "float": "left"
      }
    }, [_c('div', {
      staticClass: "beijingyangshi",
      style: ('background: url(' + _vm.newurl + item.ico + ')no-repeat center center; width: 100%;height:100%;')
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "50%",
        "height": "400px",
        "float": "right",
        "background": "#ffffff"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%",
        "padding": "30px",
        "line-height": "40px"
      }
    }, [_c('h4', {
      staticStyle: {
        "line-height": "60px",
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.date) + " "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("阅读全文 >")])])])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "chanpin_s2"
  }, [_vm._l((_vm.newslist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "chanpin_s1_02 chanpin_s1_02_xin animate zoomIn animated",
      staticStyle: {
        "animation-duration": "1s",
        "animation-delay": "1s"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "black"
      },
      attrs: {
        "href": '/blogDetails?id=' + item.id + '&cid=' + _vm.thisid
      }
    }, [_c('div', {
      staticClass: "chanpin_s101_a",
      staticStyle: {
        "border-radius": "0px",
        "border": "0px"
      }
    }, [_c('div', {
      style: ('background: url(' + _vm.newurl + item.ico + ')no-repeat center center;background-size: cover !important;width: 100%;height: 200px;')
    }), _vm._v(" "), _c('div', {
      staticClass: "xinwen912",
      staticStyle: {
        "height": "150px",
        "width": "100%",
        "background": "#ffffff",
        "padding": "30px"
      }
    }, [_c('h4', {
      staticClass: "zitikaka",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(_vm.truncatechanpinzzz(item.title)))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1, true)])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "donghuaRight",
    staticStyle: {
      "width": "100%",
      "height": "30px",
      "text-align": "center",
      "line-height": "100px",
      "animation-duration": "1s",
      "animation-delay": "0.6s",
      "margin-top": "100px"
    }
  }, [_c('div', {
    staticClass: "download-btn",
    on: {
      "click": function($event) {
        return _vm.jiazai(_vm.numzong)
      }
    }
  }, [_vm._v("\n                查看更多" + _vm._s(_vm.newtitle) + " +\n              ")])])], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "map-area section-padding news_section1 section"
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated news_sun_ziti1",
    staticStyle: {
      "animation-duration": "0.7s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("新闻中心")]), _vm._v(" "), _c('p', {
    staticClass: "p2 animate zoomIn animated news_sun_ziti2",
    staticStyle: {
      "animation-duration": "0.7s",
      "animation-delay": "1s",
      "visibility": "visible",
      "color": "red"
    }
  }, [_vm._v("NEWS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("阅读全文 > ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a3a86be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BlogHome.vue
// module id = 112
// module chunks = 0